import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-nowrap items-center gap-1 md:gap-3 w-full" }
const _hoisted_2 = { class: "text-[12px] font-semibold" }
const _hoisted_3 = { class: "flex flex-nowrap items-center gap-1 w-max bg-zinc-950 text-[#f5eded] py-1 px-2 rounded-lg inset-shadow-sm" }
const _hoisted_4 = { class: "flex flex-nowrap items-center w-max" }

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toast = _resolveComponent("Toast")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isLoggedIn)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.btnClickLogin && _ctx.btnClickLogin(...args))),
            type: "button",
            class: "cursor-pointer text-amber-50 font-bold"
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("img", {
              src: "https://tos168.sgp1.cdn.digitaloceanspaces.com/button-tos-Webp.webp",
              alt: "login",
              class: "size-8 md:size-10"
            }, null, -1 /* HOISTED */)
          ])))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.btnClickProfile && _ctx.btnClickProfile(...args))),
              class: "flex flex-nowrap items-center w-max bg-zinc-950 text-[#f5eded] py-1 px-2 rounded-lg inset-shadow-sm cursor-pointer"
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.profile?.username ?? 'กำลังโหลด...'), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.btnClickWalletDeposit && _ctx.btnClickWalletDeposit(...args))),
                class: "text-[12px] font-semibold cursor-pointer"
              }, _toDisplayString(_ctx.formatCurrency(_ctx.profile?.balance ?? 0)), 1 /* TEXT */),
              _createVNode(_component_Button, {
                onClick: _ctx.btnRefProfile,
                loading: _ctx.btnLoading,
                type: "button",
                class: "flex justify-center items-center w-max cursor-pointer p-0!",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([{'animate-spin': _ctx.btnLoading}, "size-4 font-bold"]),
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor"
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                    }, null, -1 /* HOISTED */)
                  ]), 2 /* CLASS */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick", "loading"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.btnClickLogout && _ctx.btnClickLogout(...args))),
                type: "button",
                class: "bg-red-600 rounded-full shadow p-1 cursor-pointer"
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.5",
                  stroke: "currentColor",
                  class: "size-4 text-white font-bold"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9"
                  })
                ], -1 /* HOISTED */)
              ]))
            ])
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.btnTournament && _ctx.btnTournament(...args))),
          class: _normalizeClass(["size-24 fixed z-[100]! right-0 bottom-[5rem]", {'bottom-[10rem]!': _ctx.checkPaths}])
        }, _cache[8] || (_cache[8] = [
          _createElementVNode("img", {
            src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/tournament.gif",
            alt: "Tournament"
          }, null, -1 /* HOISTED */)
        ]), 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_Toast)
  ], 64 /* STABLE_FRAGMENT */))
}